"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioModel = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var howler_1 = require("howler");
var AudioModel = (function (_super) {
    tslib_1.__extends(AudioModel, _super);
    function AudioModel() {
        var _this = _super.call(this) || this;
        _this._paused = false;
        _this._started = false;
        _this._ready = false;
        _this._isAdPlaying = false;
        _this._onBackgroundLoopEnded = function () { return _this.onBackgroundLoopEnded(); };
        _this.backgroundSounds = [{ id: "howl_music", default: true }];
        if (process.env.NODE_ENV === "development") {
            window.v_audio = _this;
        }
        return _this;
    }
    AudioModel_1 = AudioModel;
    AudioModel.prototype.initBackgroundSounds = function () {
        this.backgroundSounds.forEach(function (bgSound) {
            bgSound.howl = (0, core_1.lazyGet)(bgSound.id);
            bgSound.initiated = true;
        });
    };
    AudioModel.prototype.init = function (soundsMuted, musicMuted) {
        if (soundsMuted === void 0) { soundsMuted = false; }
        if (musicMuted === void 0) { musicMuted = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defaultBackgroundHowl;
            return tslib_1.__generator(this, function (_a) {
                this.initBackgroundSounds();
                this.addListener(interfaces_1.AdEvents.STARTED, this.onAdStarted);
                this.addListener(interfaces_1.AdEvents.ENDED, this.onAdEnded);
                this.addListener(core_1.CommonEvents.PAUSE, this.onPause);
                this.muteMusic(musicMuted);
                this.muteSounds(soundsMuted);
                defaultBackgroundHowl = this.backgroundSounds.find(function (item) { return item.default; });
                if (defaultBackgroundHowl === null || defaultBackgroundHowl === void 0 ? void 0 : defaultBackgroundHowl.howl) {
                    this.activeBackgroundHowl = defaultBackgroundHowl.howl;
                }
                this._ready = true;
                return [2, this];
            });
        });
    };
    AudioModel.prototype.soundsMuted = function () {
        return this._sounds;
    };
    AudioModel.prototype.musicMuted = function () {
        return this._music;
    };
    AudioModel.prototype.muteSounds = function (value) {
        if (this._sounds !== value) {
            this._sounds = value;
            this.dispatch(AudioModel_1.MUTE_SOUNDS, value);
            this.postData();
        }
        return this._sounds;
    };
    AudioModel.prototype.muteMusic = function (value) {
        if (this._music !== value) {
            this._music = value;
            this.tapMusic();
            this.dispatch(AudioModel_1.MUTE_MUSIC, value);
            this.postData();
        }
        return this._music;
    };
    AudioModel.prototype.activateBackgroundMusic = function () {
        this._started = true;
        this.tapMusic();
    };
    Object.defineProperty(AudioModel.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioModel.prototype, "paused", {
        get: function () {
            return this._paused;
        },
        set: function (value) {
            this._paused = value;
            this.tapMusic();
        },
        enumerable: false,
        configurable: true
    });
    AudioModel.prototype.onAdStarted = function () {
        this.isAdPlaying = true;
    };
    AudioModel.prototype.onAdEnded = function () {
        this.isAdPlaying = false;
    };
    Object.defineProperty(AudioModel.prototype, "isAdPlaying", {
        get: function () {
            return this._isAdPlaying;
        },
        set: function (val) {
            this._isAdPlaying = val;
            this.tapMusic();
        },
        enumerable: false,
        configurable: true
    });
    AudioModel.prototype.onPause = function (doPause) {
        this.paused = doPause;
    };
    AudioModel.prototype.postData = function () {
        var _a = this, sounds = _a._sounds, music = _a._music;
        this.cookie.save(AudioModel_1.COOKIE_KEY, { sounds: sounds, music: music });
    };
    AudioModel.prototype.tapMusic = function () {
        if (this._ready && this._started) {
            var paused = this._isAdPlaying || (!this._isAdPlaying && this._paused);
            this.runMusicAction(!this._music && !paused);
        }
    };
    AudioModel.prototype.runMusicAction = function (active) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var howlInstance;
            return tslib_1.__generator(this, function (_b) {
                howlInstance = this._activeBackgroundHowl;
                return [2, (_a = (0, core_1.lazyGet)(interfaces_1.TypesAudio.musicAction)) === null || _a === void 0 ? void 0 : _a.run({
                        active: active,
                        howlInstance: howlInstance
                    })];
            });
        });
    };
    AudioModel.prototype.onBackgroundLoopEnded = function () {
        this.changeBackgroundMusic();
    };
    AudioModel.prototype.changeBackgroundMusic = function (track) {
        var _a;
        this.activeBackgroundHowl = (_a = this.backgroundSounds.find(function (item) { return item.id === track; })) === null || _a === void 0 ? void 0 : _a.howl;
    };
    AudioModel.prototype.disableOnBackgroundLoopEnded = function (howl) {
        if (howl) {
            howl.off("end", this._onBackgroundLoopEnded);
        }
    };
    AudioModel.prototype.enableOnBackgroundLoopEnded = function (howl) {
        if (howl) {
            howl.on("end", this._onBackgroundLoopEnded);
        }
    };
    Object.defineProperty(AudioModel.prototype, "activeBackgroundHowl", {
        get: function () {
            return this._activeBackgroundHowl;
        },
        set: function (value) {
            if (!value || this._activeBackgroundHowl === value) {
                return;
            }
            var lastHowl = this._activeBackgroundHowl;
            this.disableOnBackgroundLoopEnded(this._activeBackgroundHowl);
            if (this._activeBackgroundHowl) {
                this.runMusicAction(false);
            }
            this._activeBackgroundHowl = value;
            this.enableOnBackgroundLoopEnded(this._activeBackgroundHowl);
            if (lastHowl !== this._activeBackgroundHowl) {
                this.activateBackgroundMusic();
            }
        },
        enumerable: false,
        configurable: true
    });
    var AudioModel_1;
    AudioModel.COOKIE_KEY = "audio";
    AudioModel.MUTE_MUSIC = "AudioModel.MUTE_MUSIC";
    AudioModel.MUTE_SOUNDS = "AudioModel.MUTE_SOUNDS";
    tslib_1.__decorate([
        (0, core_1.lazyInject)("howl_sounds"),
        tslib_1.__metadata("design:type", howler_1.Howl)
    ], AudioModel.prototype, "howl", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.cookie),
        tslib_1.__metadata("design:type", Object)
    ], AudioModel.prototype, "cookie", void 0);
    AudioModel = AudioModel_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)(),
        tslib_1.__metadata("design:paramtypes", [])
    ], AudioModel);
    return AudioModel;
}(core_1.GlobalEventProvider));
exports.AudioModel = AudioModel;
//# sourceMappingURL=AudioModel.js.map